import { TStoreState } from 'redux/types';
import { createSelector } from '@reduxjs/toolkit';
import {
	TEmailsStore,
	TEmailsListResponsePayload,
	TEmailsTypesResponsePayload,
} from './types';

export const getEmailsState = (state: TStoreState): TEmailsStore => state.emails;

// ==========================================:
// Emails list
export const getEmailsList = createSelector(
	[getEmailsState],
	(emails: TEmailsStore) => emails.emailsList,
);

export const getEmailsListData = createSelector(
	[getEmailsList],
	(emailsList: TEmailsListResponsePayload) => emailsList,
);

export const getEmailsListLoading = createSelector(
	[getEmailsState],
	(emails: TEmailsStore) => emails.emailsListLoading,
);

// ==========================================:
// Emails types
export const getEmailsTypes = createSelector(
	[getEmailsState],
	(emails: TEmailsStore) => emails.emailsTypes,
);

export const getEmailsTypesData = createSelector(
	[getEmailsTypes],
	(emailsTypes: TEmailsTypesResponsePayload) => emailsTypes,
);

export const getEmailsTypesLoading = createSelector(
	[getEmailsState],
	(emails: TEmailsStore) => emails.emailsTypesLoading,
);
